<template>
    <!-- <Breadcrumbs main="Setting" mains="Patient Management" title="Patient Management" /> -->
    <div class="container-fluid default-dashboard">
        <div class="card">
            <div class="card-header">
                <div class="d-flex justify-content-between align-items-center">
                    <h5>Report Closing</h5>
                    <div class="d-flex align-items-center gap-2">
                        <div v-if="role == 'FINANCE'" style="width: 200px">
                            <select v-model="(params as any).clinic" class="form-select">
                                <option :value="null" disabled>Select Clinic</option>
                                <option v-for="option in session.clinicOptions()" :key="option.ID" :value="option.name">
                                    {{ (option as any).description }}
                                </option>
                            </select>
                        </div>
                        <div class="d-flex gap-2">
                            <button :class="role != 'FINANCE' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-primary'"
                                @click="processDownload" :disabled="loading">
                                <i class="fa fa-solid fa-plus"></i>XLS
                            </button>
                            <button :class="role != 'FINANCE' ? 'btn btn-sm btn-secondary' : 'btn btn-sm btn-secondary'"
                                @click="processExportPDF" :disabled="loading || pdfExportProgress.isExporting">
                                <i class="fa fa-file-pdf"></i>
                                <span v-if="pdfExportProgress.isExporting">Generating...</span>
                                <span v-else>PDF</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 p-3">
                <div class="d-flex align-items-center gap-3">
                    <multiselect v-model="params.status" tag-placeholder="Select Status" placeholder="Select Status"
                        label="name" track-by="code" :multiple="true" :taggable="true" :options="[
                            { code: 'Pasien Daftar', name: 'Pasien Daftar' },
                            { code: 'Pasien Baru', name: 'Pasien Baru' },
                            { code: 'Pasien Ulang', name: 'Pasien Ulang' },
                            { code: 'Pasien Mencoba Terapi', name: 'Pasien Mencoba Terapi' },
                            { code: 'Pasien Lunas', name: 'Pasien Lunas' },
                            { code: 'Pasien Tanya-Tanya', name: 'Pasien Tanya-Tanya' },
                            { code: 'Pasien Beli Obat', name: 'Pasien Beli Obat' },
                            { code: 'Pasien Beli Minya', name: 'Pasien Beli Minyak' }
                        ]">
                    </multiselect>
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="includeRole" v-model="includeRole">
                        <label class="form-check-label" for="includeRole">
                            Print_CS
                        </label>
                    </div>
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="includeEmail" v-model="includeEmail">
                        <label class="form-check-label" for="includeEmail">
                            By_User
                        </label>
                    </div>
                    <!-- New inputs for PDF Header & Title -->
                    <div class="input-group" style="max-width: 300px">
                        <span class="input-group-text">Header</span>
                        <input v-model="pdfHeader" type="text" class="form-control" placeholder="Header PDF" />
                    </div>
                    <div class="input-group" style="max-width: 300px">
                        <span class="input-group-text">Title</span>
                        <input v-model="pdfTitle" type="text" class="form-control" placeholder="Title PDF" />
                    </div>
                </div>
            </div>
            <div class="card-body">
                <DataTable :headers="headers" :items="patients" :loading="loading" :total="total" :params="params"
                    @update:params="updateParams">
                    <template #item.patient_photo="{ item }">
                        <div class="d-flex align-items-center">
                            <div class="avatar" style="border-color: blueviolet;"
                                @click="changePhoto(item)">
                                <img v-if="item.registration_sales_photo" :src="item.registration_sales_photo"
                                    class="rounded-circle" width="40" height="40" :alt="item.name">
                                <div v-else
                                    class="rounded-circle bg-light d-flex align-items-center justify-content-center"
                                    style="width: 40px; height: 40px;">
                                    <i class="fa fa-user text-secondary"></i>
                                </div>
                            </div>&nbsp;
                            <div class="avatar">
                                <img v-if="item.registration_photo" :src="item.registration_photo"
                                    class="rounded-circle" width="40" height="40" :alt="item.name">
                                <div v-else
                                    class="rounded-circle bg-light d-flex align-items-center justify-content-center"
                                    style="width: 40px; height: 40px;">
                                    <i class="fa fa-user text-secondary"></i>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template #item.registration_date="{ item }">
                        {{ formatDateTime(item.registration_date) }}
                    </template>
                    <template #item.address="{ item }">
                        {{ item.patient.address }}
                    </template>
                </DataTable>
            </div>
        </div>
    </div>

    <!-- Photo Upload Modal -->
    <div class="modal fade" id="photoModal" tabindex="-1" aria-labelledby="photoModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="photoModalLabel">Change Photo</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="mb-3">
                        <label class="form-label">Upload Photo</label>
                        <Upload pathFile="/clinic" @on-success="(event: string) => handlePhotoUpload(event)"
                            @on-change="(event: string) => handlePhotoUpload(event)" />
                    </div>

                    <div v-if="selectedPatient && selectedPatient.registration_sales_photo" class="mt-3">
                        <label class="form-label">Current Photo:</label>
                        <img :src="selectedPatient.registration_sales_photo" alt="Current Photo"
                            class="img-fluid rounded" style="max-height: 200px; object-fit: contain;" />
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" @click="savePhoto" :disabled="!uploadedPhotoUrl">Save
                        Photo</button>
                </div>
            </div>
        </div>
    </div>

    <!-- PDF Export Progress Modal -->
    <div class="modal fade" id="pdfProgressModal" tabindex="-1" aria-labelledby="pdfProgressModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="pdfProgressModalLabel">
                        <i class="fa fa-file-pdf text-danger me-2"></i>
                        PDF Export Progress
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                        :disabled="pdfExportProgress.isExporting"></button>
                </div>
                <div class="modal-body">
                    <div v-if="pdfExportProgress.isExporting">
                        <div class="text-center mb-3">
                            <div class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>

                        <div class="mb-3">
                            <label class="form-label fw-bold">Progress:</label>
                            <div class="progress mb-2" style="height: 25px;">
                                <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                                    :style="`width: ${pdfExportProgress.percentage}%`"
                                    :aria-valuenow="pdfExportProgress.percentage" aria-valuemin="0" aria-valuemax="100">
                                    {{ pdfExportProgress.percentage }}%
                                </div>
                            </div>
                            <small class="text-muted">{{ pdfExportProgress.progress }}</small>
                        </div>

                        <div class="alert alert-info mb-0">
                            <i class="fa fa-info-circle me-2"></i>
                            Please wait while we generate your PDF report. This may take a few minutes for large
                            datasets.
                        </div>
                    </div>

                    <div v-else-if="pdfExportProgress.error" class="alert alert-danger">
                        <i class="fa fa-exclamation-triangle me-2"></i>
                        <strong>Error:</strong> {{ pdfExportProgress.error }}
                    </div>

                    <div v-else class="alert alert-success">
                        <i class="fa fa-check-circle me-2"></i>
                        PDF export completed successfully!
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                        :disabled="pdfExportProgress.isExporting">
                        <span v-if="pdfExportProgress.isExporting">Cancel</span>
                        <span v-else>Close</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref, reactive, onMounted, defineAsyncComponent, watch } from 'vue'
import { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import DataTable from '@/components/table/DatatableDateRange.vue'
import { useSessionStore } from '@/store/session';
import { Modal } from 'bootstrap'
const Upload = defineAsyncComponent(() => import("@/components/input/Uploads.vue"))
const session = useSessionStore()

const headers = [
    { text: 'Photo', value: 'patient_photo' },
    { text: 'Status', value: 'status' },
    { text: 'Info', value: 'information' },
    { text: 'Name', value: 'name' },
    { text: 'Telp', value: 'no_telp' },
    { text: 'Address', value: 'address' },
    { text: 'Sales', value: 'sales_name' },
    { text: 'Registration', value: 'registration_date' },
    { text: 'Therapy', value: 'therapy_note' },
    { text: 'Penaganan', value: 'therapy_handling_note' },
    { text: 'Obat', value: 'obat_note' },
]

// {{ Apply types to refs and reactive objects }}
const clinics = session.getUser().clinic
const email = session.getUser().email
const role = ref(session.getUser().role)
const patients = ref<any[]>([])
const loading = ref(false)
const total = ref(0)
const selectedPatient = ref<any>(null)
const uploadedPhotoUrl = ref<string>('')
const pdfExportProgress = ref({
    isExporting: false,
    progress: '',
    percentage: 0,
    exportCode: '',
    error: null as string | null
})
// New refs for PDF header & title
const pdfHeader = ref<string>('')
const pdfTitle = ref<string>('')
const includeRole = ref(false)
const includeEmail = ref(false)
const params = reactive<DataTableParams>({
    page: 1,
    size: 10,
    search: '',
    status: [],
    clinic: clinics,
    email: ''
})

// Watch for includeEmail changes and update params.email accordingly
watch(includeEmail, (newValue) => {
    if (newValue) {
        params.email = email
    } else {
        params.email = ''
    }
})

// Add this data data array
import * as clinic from "@/api/services/ClinicRequest";

const fetchPatient = async () => {
    loading.value = true
    try {
        // Simulate API delay
        const prms = { ...params }
        if (prms.status && Array.isArray(prms.status)) {
            prms.status = prms.status.map(s => s.code).join(',')
        }
        const resp = await clinic.postRequest("/registration/list", { ...prms });
        patients.value = resp.data
        total.value = resp.total

    } catch (error) {
        toast.error('Failed to fetch patients')
    }
    loading.value = false
}

// {{ Add type annotation for newParams }}
const updateParams = (newParams: Partial<DataTableParams>) => {
    Object.assign(params, newParams)
    fetchPatient()
}

onMounted(() => {
    role.value = session.getUser().role
})

const processDownload = async () => {
    loading.value = true;
    try {
        const prms = { ...params };
        if (prms.status && Array.isArray(prms.status)) {
            prms.status = prms.status.map(s => s.code).join(',');
        }
        // Set clinicName from the selected clinic's description in the dropdown
        prms.clinicName = session.clinicOptions().find(clinic => clinic.name === prms.clinic)?.description || '';
        prms.size = 100000;
        try {
            const response = await clinic.getDownload("/registration/xlsx", prms);
            const blob = new Blob([response], { type: 'application/vnd.ms-excel' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'patient-registration.xlsx');
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error downloading file:', error);
            toast.error('Failed to download file. Please try again.');
        }
    } catch (error) {
        toast.error('Failed to fetch salesOrders');
    }
    loading.value = false;
};

const processExportPDF = async () => {
    loading.value = true
    pdfExportProgress.value = {
        isExporting: true,
        progress: 'Initializing: 0%',
        percentage: 0,
        exportCode: '',
        error: null
    }

    try {
        const prms = { ...params }
        if (prms.status && Array.isArray(prms.status)) {
            prms.status = prms.status.map(s => s.code).join(',')
        }
        prms.size = 100000
        if (includeRole.value) {
            prms.role = session.getUser().role
        }
        prms.async = 'true' // Enable async mode
        // Include header & title in request params
        ;(prms as any).header = pdfHeader.value || 'Laporan Tutupan'
        ;(prms as any).title = pdfTitle.value || 'Closing Pasien'

        try {
            // Start async PDF generation
            const response = await clinic.postRequest("/registration/exportpdf", prms);

            if (response.export_code) {
                pdfExportProgress.value.exportCode = response.export_code
                toast.success('PDF generation started. Please wait...')

                // Show progress modal
                const modal = new Modal(document.getElementById('pdfProgressModal')!)
                modal.show()

                // Start polling for progress
                pollPdfProgress(response.export_code)
            } else {
                throw new Error('No export code received')
            }
        } catch (error) {
            console.error('Error starting PDF export:', error);
            toast.error('Failed to start PDF export. Please try again.');
            pdfExportProgress.value.isExporting = false
            pdfExportProgress.value.error = 'Failed to start PDF export'
        }
    } catch (error) {
        toast.error('Failed to prepare PDF export parameters');
        pdfExportProgress.value.isExporting = false
        pdfExportProgress.value.error = 'Failed to prepare export parameters'
    }
    loading.value = false
}

const pollPdfProgress = async (exportCode: string) => {
    const pollInterval = setInterval(async () => {
        try {
            const progressResponse = await clinic.getRequest(`/registration/pdf-export-progress/${exportCode}`, {})

            // Update progress state
            pdfExportProgress.value.progress = progressResponse.progress || 'Processing...'

            // Extract percentage from progress string
            const percentMatch = progressResponse.progress?.match(/(\d+)%/)
            if (percentMatch) {
                pdfExportProgress.value.percentage = parseInt(percentMatch[1])
            }

            // Check if completed
            if (progressResponse.status === true) {
                clearInterval(pollInterval)
                pdfExportProgress.value.isExporting = false
                pdfExportProgress.value.progress = 'Completed: 100%'
                pdfExportProgress.value.percentage = 100

                toast.success('PDF generation completed! Downloading...')

                // Download the file
                try {
                    const downloadResponse = await clinic.getDownload(`/registration/download-pdf/${exportCode}`, {})
                    const blob = new Blob([downloadResponse], { type: 'application/pdf' })
                    const url = window.URL.createObjectURL(blob)
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', progressResponse.file_name || 'registration-report.pdf')
                    document.body.appendChild(link)
                    link.click()
                    window.URL.revokeObjectURL(url)
                    document.body.removeChild(link)
                } catch (downloadError) {
                    console.error('Error downloading PDF:', downloadError)
                    toast.error('PDF generated but download failed. Please try again.')
                }
            } else if (progressResponse.error_message) {
                // Handle error
                clearInterval(pollInterval)
                pdfExportProgress.value.isExporting = false
                pdfExportProgress.value.error = progressResponse.error_message
                toast.error(`PDF generation failed: ${progressResponse.error_message}`)
            }
        } catch (error) {
            console.error('Error polling PDF progress:', error)
            // Continue polling unless it's a critical error
            if (error instanceof Error && (error as any).response?.status === 404) {
                clearInterval(pollInterval)
                pdfExportProgress.value.isExporting = false
                pdfExportProgress.value.error = 'Export not found'
                toast.error('PDF export not found. Please try again.')
            }
        }
    }, 2000) // Poll every 2 seconds

    // Set timeout to stop polling after 10 minutes
    setTimeout(() => {
        clearInterval(pollInterval)
        if (pdfExportProgress.value.isExporting) {
            pdfExportProgress.value.isExporting = false
            pdfExportProgress.value.error = 'Export timeout'
            toast.error('PDF export timed out. Please try again.')
        }
    }, 600000) // 10 minutes timeout
}

function formatDateTime(dateString: string, part: string = "-", partTime: string = " "): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    const hh = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    return `${dd}${part}${mm}${part}${yyyy}${partTime}${hh}:${min}`;
}

// Photo upload functions
const changePhoto = (patient: any) => {
    selectedPatient.value = patient
    uploadedPhotoUrl.value = ''
    const modal = new Modal(document.getElementById('photoModal')!)
    modal.show()
}

const handlePhotoUpload = (event: string) => {
    uploadedPhotoUrl.value = event
}

const savePhoto = async () => {
    if (!selectedPatient.value || !uploadedPhotoUrl.value) {
        toast.error('Please select a photo to upload')
        return
    }

    try {
        loading.value = true
        await clinic.postRequest('/registration/regis-sales-upload', {
            code: selectedPatient.value.code,
            image: uploadedPhotoUrl.value
        })
    } catch (error) {
        console.error('Error updating photo:', error)
        toast.error('Failed to update photo')
    } finally {
        loading.value = false
        fetchPatient();
        const modal = Modal.getInstance(document.getElementById('photoModal')!)
        modal?.hide()
    }
}
</script>